export function normalizeWebhookCallbackUrl(value) {
  if (typeof value !== "string") return "";

  return value.replace(
    "/api/meta/webhook/",
    "/meta/webhook/"
  );
}
